// extracted by mini-css-extract-plugin
export default {"section":"Ds-z","inSectionButton":"Es-z","addressCard":"Fs-z","disabled":"Gs-z","cautionBox":"Hs-z","failureBox":"Is-z","fade-out":"Js-z","successBox":"Ks-z"};